import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LiveIcon } from 'components';
import globalMessages from 'messages';
import './mobileTopMenuLive.scss';

const MobileTopMenuLive: React.FC = () => {
    return (
        <React.Fragment>
            <div styleName="live-icon">
                <LiveIcon />
            </div>
            <FormattedMessage {...globalMessages.live} />
        </React.Fragment>
    );
};

export default MobileTopMenuLive;
